import { render, staticRenderFns } from "./DeviceStatus.vue?vue&type=template&id=47995747"
import script from "./DeviceStatus.vue?vue&type=script&lang=js"
export * from "./DeviceStatus.vue?vue&type=script&lang=js"
import style0 from "./DeviceStatus.vue?vue&type=style&index=0&id=47995747&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DeviceStatus.vue?vue&type=custom&index=0&blockType=meta&name=viewport&content=width%3Ddevice-width%2C%20initial-scale%3D1.0"
if (typeof block0 === 'function') block0(component)

export default component.exports